import { generator } from '../event-listener.js';
export const OnBeforeCancel = generator('onBeforeCancel');
export const OnBeforeSubmit = generator('onBeforeSubmit');
export const OnCancel = generator('onCancel');
export const OnSubmit = generator('onSubmit');
//# sourceMappingURL=submittable.js.map